import type { ReactNode } from 'react';
import type { RouteObject } from 'react-router';

import { Outlet } from 'react-router';
import { lazy, Suspense } from 'react';

import { SplashScreen } from 'src/components/loading-screen';

import { GuestGuard } from 'src/auth/guard';

import { AuthCenteredLayout } from '../../layouts/auth-centered';

// ----------------------------------------------------------------------

/** **************************************
 * Jwt
 *************************************** */
const Jwt = {
  SignInPage: lazy(() => import('src/pages/auth/sign-in')),
  ForgotPasswordPage: lazy(() => import('src/pages/auth/forgot-password')),
  ResetPasswordPage: lazy(() => import('src/pages/auth/reset-password')),
};

// Every jwt auth page shares the same guest-only, centered-layout shell.
const withAuthShell = (page: ReactNode) => (
  <GuestGuard>
    <AuthCenteredLayout
      slotProps={{
        header: {
          disableOffset: true,
          disableElevation: true,
          sx: { zIndex: 9, position: { md: 'relative' } },
        },
      }}
    >
      {page}
    </AuthCenteredLayout>
  </GuestGuard>
);

const authJwt = {
  path: 'jwt',
  children: [
    { path: 'sign-in', element: withAuthShell(<Jwt.SignInPage />) },
    { path: 'forgot-password', element: withAuthShell(<Jwt.ForgotPasswordPage />) },
    { path: 'reset-password', element: withAuthShell(<Jwt.ResetPasswordPage />) },
  ],
};

// ----------------------------------------------------------------------

export const authRoutes: RouteObject[] = [
  {
    path: 'auth',
    element: (
      <Suspense fallback={<SplashScreen />}>
        <Outlet />
      </Suspense>
    ),
    children: [authJwt],
  },
];
